import { render, staticRenderFns } from "./AssetsEstatePlanning.vue?vue&type=template&id=7d144fe0"
import script from "./AssetsEstatePlanning.vue?vue&type=script&lang=js"
export * from "./AssetsEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports